import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import LeftArrow from '@material-ui/icons/KeyboardBackspaceOutlined';
import ShoppingCart from '@material-ui/icons/ShoppingCartOutlined';
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import HeaderInfo from './HeaderInfo';
import Logo from 'components/Logo'
import { toggleSidebar } from 'redux/actions';

const Header = () => {
    const sidebar = useSelector((state) => state.sidebar);
    const { _token } = useSelector((state) => state.sign);
    const headerClasses = cx('header', 'shadow-sm');
    const columnsClasses = cx('d-flex', 'align-items-center', 'header__col');
    const columnsClassesMobile = cx('d-flex', 'align-items-right');
    const logoColumnClasses = cx('d-flex', 'align-items-center', 'justify-content-center');
    const dispatch = useDispatch();

    const handleOpen = (e) => dispatch(toggleSidebar());

    sidebar.open
        ? document.body.classList.add('body--is-sidebar__open')
        : document.body.classList.remove('body--is-sidebar__open');

    return (
        <Navbar expand="lg" fixed="sticky" className={headerClasses}>
            <Container className="container-main">
                <Row className="w-100">
                    {_token && <Navbar.Toggle aria-controls="basic-navbar-nav" className="header__navbar" onClick={handleOpen} />}
                    <Col xs={2} md={3} lg={3} className={_token ? columnsClasses : columnsClassesMobile}>
                        <Button variant="link" className="header__button" href={process.env.REACT_APP_SHOP}>
                            <LeftArrow />
                            <span>Powrót do sklepu</span>
                        </Button>
                    </Col>
                    <Col xs lg={6} className={logoColumnClasses}>
                        <Navbar.Brand href="/" className="m-0 p-0">
                            <Logo className="" />
                        </Navbar.Brand>
                    </Col>
                    <Col xs lg={3} md={3} className={columnsClasses}>
                        <HeaderInfo />
                    </Col>
                    <Col xs={2} className={columnsClassesMobile}>
                        {_token && <Button variant="link" className="header__button header__button--mobile" href={process.env.REACT_APP_SHOP}>
                            <ShoppingCart />
                        </Button>}
                    </Col>
                </Row>
            </Container>
        </Navbar >
    );
};

export default Header;
